module.exports = __webpack_public_path__ + "img/REGISTRO 5.da0a066d.png";